// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/flags/v1/flags.proto (package chalk.flags.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/flags/v1/flags.proto.
 */
export const file_chalk_flags_v1_flags: GenFile = /*@__PURE__*/
  fileDesc("ChpjaGFsay9mbGFncy92MS9mbGFncy5wcm90bxIOY2hhbGsuZmxhZ3MudjEiQQoHT3B0aW9ucxIMCgRuYW1lGAEgASgJEhgKC2Rlc2NyaXB0aW9uGAIgASgJSACIAQFCDgoMX2Rlc2NyaXB0aW9uOlAKBGZsYWcSHi5nb29nbGUucHJvdG9idWYuTWV0aG9kT3B0aW9ucxiy6gEgASgLMhcuY2hhbGsuZmxhZ3MudjEuT3B0aW9uc1IEZmxhZ4gBAUISWhBmbGFncy92MTtmbGFnc3YxYgZwcm90bzM", [file_google_protobuf_descriptor]);

/**
 * @generated from message chalk.flags.v1.Options
 */
export type Options = Message<"chalk.flags.v1.Options"> & {
  /**
   * The feature flag name that must be enabled for this RPC to be accessible
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional description of why this feature flag is required
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;
};

/**
 * Describes the message chalk.flags.v1.Options.
 * Use `create(OptionsSchema)` to create a new message.
 */
export const OptionsSchema: GenMessage<Options> = /*@__PURE__*/
  messageDesc(file_chalk_flags_v1_flags, 0);

/**
 * @generated from extension: optional chalk.flags.v1.Options flag = 30002;
 */
export const flag: GenExtension<MethodOptions, Options> = /*@__PURE__*/
  extDesc(file_chalk_flags_v1_flags, 0);

